import React from 'react';
import { BodyText, Card, FlexRow, FormCell, Grid, NavigationItem } from 'ui-toolkit';
import styled from 'styled-components';
import { IStandardDocumentData } from '../../../types/order/documents/shared/interfaces';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { downloadLatestDocument } from '../../../API/order/documents/downloadDocument';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { ePrettyCurativeGradeType } from '../../../ui-toolkit/orders/interfaces/titleReport/eCurativeGradeType';
import { ITitleReportData } from '../../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

interface ITitleSearchReportPageProps {
  titleReport: ITitleReportData;
  commitmentDocument?: IStandardDocumentData;
  titleReportExist?: boolean;
  orderId: string;
  commitmentEditable: boolean;
  taxCertDocument?: IStandardDocumentData;
}

export const TitleSearchReportPage: React.FC<ITitleSearchReportPageProps> = ({
  titleReport,
  titleReportExist,
  orderId,
  commitmentDocument,
  commitmentEditable,
  taxCertDocument,
}) => {
  return (
    <Card title={'Search Report and Title Commitment'}>
      {titleReportExist ? (
        <Grid>
          <FormCell label={'CURATIVE GRADE'} wrapInput={false}>
            <BodyTextWithMargin>
              {titleReport.summary && titleReport.summary.curativeGrade
                ? ePrettyCurativeGradeType[titleReport.summary.curativeGrade]
                : '-'}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'OPEN MORTGAGES'} wrapInput={false}>
            <BodyTextWithMargin>
              count:{' '}
              {titleReport.summary && titleReport.summary.openMortgages ? titleReport.summary.openMortgages : null}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'BANKRUPTCIES'} wrapInput={false}>
            <BodyTextWithMargin>
              count: {titleReport.summary && titleReport.summary.bankruptcies ? titleReport.summary.bankruptcies : null}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'JUDGEMENTS'} wrapInput={false}>
            <BodyTextWithMargin>
              count: {titleReport.summary && titleReport.summary.judgements ? titleReport.summary.judgements : null}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'OTHER LIENS'} wrapInput={false}>
            <BodyTextWithMargin>
              count: {titleReport.summary && titleReport.summary.otherLiens ? titleReport.summary.otherLiens : null}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={"ASSESSOR'S PARCEL NUMBER / TAX ID"} wrapInput={false}>
            <BodyTextWithMargin>
              {titleReport.summary && titleReport.summary.apn ? titleReport.summary.apn : '-'}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'EFFECTIVE DATE'} wrapInput={false}>
            <BodyTextWithMargin>
              {titleReport.summary && titleReport.summary.effectiveDate
                ? getDateString(DateFormat.hugeDate, titleReport.summary.effectiveDate)
                : '-'}
            </BodyTextWithMargin>
          </FormCell>
          <FormCell label={'COMMITMENT'} wrapInput={false}>
            {commitmentDocument ? (
              <>
                <BodyTextWithMargin>
                  File:{' '}
                  <NavigationItem
                    text={commitmentDocument.fileName}
                    onClick={() => downloadLatestDocument(commitmentDocument.id, commitmentDocument.fileName)}
                    isInline
                  />
                </BodyTextWithMargin>
                <BodyTextWithMargin>{`Generated On: ${getDateString(
                  DateFormat.hugeDateTime,
                  commitmentDocument.createdAt,
                  true
                )}`}</BodyTextWithMargin>
                <FlexRow>
                  <NavigationItem
                    appearance={'default'}
                    intent={'primary'}
                    text={'Edit'}
                    to={clientUrls.urlFor.searchReport(eAccessControlUserType.Admin, orderId, 'edit')}
                  />
                </FlexRow>
              </>
            ) : (
              <>
                <BodyTextWithMargin>File still generating, please come back later.</BodyTextWithMargin>
                {commitmentEditable ? null : (
                  <FlexRow>
                    <NavigationItem
                      appearance={'primary'}
                      intent={'primary'}
                      text={'Edit'}
                      to={clientUrls.urlFor.searchReport(eAccessControlUserType.Admin, orderId, 'edit')}
                    />
                  </FlexRow>
                )}
              </>
            )}
          </FormCell>
          <FormCell label={'TAX CERTIFICATION'} wrapInput={false}>
            {taxCertDocument ? (
              <>
                <BodyTextWithMargin>
                  File:{' '}
                  <NavigationItem
                    text={taxCertDocument.fileName}
                    onClick={() => downloadLatestDocument(taxCertDocument.id, taxCertDocument.fileName)}
                    isInline
                  />
                </BodyTextWithMargin>
                <BodyTextWithMargin>{`Generated On: ${getDateString(
                  DateFormat.hugeDateTime,
                  taxCertDocument.createdAt,
                  true
                )}`}</BodyTextWithMargin>
                <FlexRow>
                  <NavigationItem
                    appearance={'default'}
                    intent={'primary'}
                    text={'Edit'}
                    to={clientUrls.urlFor.taxCertification(eAccessControlUserType.Admin, orderId, 'edit')}
                  />
                </FlexRow>
              </>
            ) : (
              <>
                <BodyTextWithMargin>File still generating, please come back later.</BodyTextWithMargin>
                {commitmentEditable ? null : (
                  <FlexRow>
                    <NavigationItem
                      appearance={'primary'}
                      intent={'primary'}
                      text={'Edit'}
                      to={clientUrls.urlFor.taxCertification(eAccessControlUserType.Admin, orderId, 'edit')}
                    />
                  </FlexRow>
                )}
              </>
            )}
          </FormCell>
        </Grid>
      ) : (
        <FlexRow>
          <NavigationItem
            appearance={'primary'}
            intent={'primary'}
            text={'Create'}
            to={clientUrls.urlFor.searchReport(eAccessControlUserType.Admin, orderId, 'create')}
          />
        </FlexRow>
      )}
    </Card>
  );
};

const BodyTextWithMargin = styled(BodyText)`
  margin-left: 32px;
`;
